import axios from 'axios'

export default {
    get: () => axios.get('events-status'),
    store: (data) => axios.post('events-status/store', data),
    update: (data) => axios.post('events-status/update', data),
    delete: (id) => axios.post('events-status/delete', id)
}